"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

const CUSTOM_OBJECT_VALUE = {};
const CUSTOM_OBJECT_VALUE_LABEL = "Object With Custom Fields";
const CUSTOM_ARRAY_VALUE = [];
const CUSTOM_ARRAY_VALUE_LABEL = "List With Custom Items";
function isCustomFieldValue(value) {
  return [JSON.stringify(CUSTOM_OBJECT_VALUE), JSON.stringify(CUSTOM_ARRAY_VALUE)].includes(JSON.stringify(value));
}

export { CUSTOM_ARRAY_VALUE, CUSTOM_ARRAY_VALUE_LABEL, CUSTOM_OBJECT_VALUE, CUSTOM_OBJECT_VALUE_LABEL, isCustomFieldValue };
